<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    viewBox="0 0 512 512"
  >
    <title></title>
    <g id="icomoon-ignore"></g>
    <path
      :fill="colorx"
      d="M488 384h-8v-104c0-30.878-25.121-56-56-56h-136v-64h8c13.2 0 24-10.8 24-24v-80c0-13.2-10.8-24-24-24h-80c-13.2 0-24 10.8-24 24v80c0 13.2 10.8 24 24 24h8v64h-136c-30.878 0-56 25.122-56 56v104h-8c-13.2 0-24 10.8-24 24v80c0 13.2 10.8 24 24 24h80c13.2 0 24-10.8 24-24v-80c0-13.2-10.8-24-24-24h-8v-96h128v96h-8c-13.2 0-24 10.8-24 24v80c0 13.2 10.8 24 24 24h80c13.2 0 24-10.8 24-24v-80c0-13.2-10.8-24-24-24h-8v-96h128v96h-8c-13.2 0-24 10.8-24 24v80c0 13.2 10.8 24 24 24h80c13.2 0 24-10.8 24-24v-80c0-13.2-10.8-24-24-24zM96 480h-64v-64h64v64zM288 480h-64v-64h64v64zM224 128v-64h64v64h-64zM480 480h-64v-64h64v64z"
    ></path>
  </svg>
</template>
<script>
export default {
  data: () => ({}),
  props: {
    colorx: {
      type: String,
      default: "#89899B"
    }
  }
};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/shared/icons/DeviceIcon.vue